import {
  AttributablePayYearViewModel,
  EmployeeIdentificationType,
  EmploymentPeriodStatusEnum,
  FokParameterType,
  MarkupStatusEnum,
  PayReportingTableRowViewModel,
  PayReportingTableViewModel,
} from '@fora-monorepo/employer-my-pages-common/types';

const availableAttributablePayYears: AttributablePayYearViewModel[] = [
  {
    year: 2024,
    months: [
      { monthShort: 'Dec', disabled: false, monthNo: '12' },
      { monthShort: 'Nov', disabled: false, monthNo: '11' },
      { monthShort: 'Okt', disabled: false, monthNo: '10' },
      { monthShort: 'Sep', disabled: false, monthNo: '09' },
      { monthShort: 'Aug', disabled: true, monthNo: '08' },
      { monthShort: 'Juli', disabled: false, monthNo: '07' },
      { monthShort: 'Juni', disabled: false, monthNo: '06' },
      { monthShort: 'Maj', disabled: false, monthNo: '05' },
      { monthShort: 'Apr', disabled: false, monthNo: '04' },
      { monthShort: 'Mars', disabled: false, monthNo: '03' },
      { monthShort: 'Feb', disabled: false, monthNo: '02' },
      { monthShort: 'Jan', disabled: false, monthNo: '01' },
    ],
  },
];

const employee1: PayReportingTableRowViewModel = {
  foraAgreementNumber: '00000000004010000783',
  policyNumber: '500000001092',
  employee: {
    employeeId: '196201051222',
    partnerNumberIndividual: '0032695381',
    identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
    firstName: 'Kalle',
    lastName: 'Karlsson',
    address: {
      streetAddress: 'Street address',
      streetAddress2: '',
      postalCode: '11111',
      city: 'Stockholm',
      countryCode: 'SE',
    },
    birthDate: '',
    deathDate: '',
    isVerified: false,
  },
  employmentPeriods: [
    {
      employmentStartDate: '2021-01-01',
      employmentEndDate: null,
      markups: [
        {
          faGroupId: '0000039884',
          fokId: '12345',
          fokText: 'Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
          startDate: '2021-01-01T00:00:00',
          endDate: null,
          status: MarkupStatusEnum.Active,
        },
      ],
      employmentStatus: EmploymentPeriodStatusEnum.Active,
      fokParameterChoices: [
        {
          parameterValue: FokParameterType.KPAfter65,
          startDate: '2021-01-01T00:00:00',
          endDate: null,
        },
      ],
    },
  ],
  payAmountDraft: null,
  payAmountReported: null,
  attributablePayDraft: null,
  attributablePayReported: null,
  isInactive: false,
  isTerminated: false,
  isFuture: false,
  activeMarkup: {
    faGroupId: '0000039884',
    fokId: '12345',
    fokText: 'Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
    startDate: '2021-01-01T00:00:00',
    endDate: null,
    fokIsExpiring: null,
    fokParameterChoices: [
      {
        parameterValue: FokParameterType.KPAfter65,
        startDate: '2021-01-01T00:00:00',
        endDate: null,
      },
    ],
    status: MarkupStatusEnum.Active,
  },
  availableAttributablePayYears,
  hasFokParameterChoices: true,
  isAbovePensionIncomeAge: false,
};

const employee2: PayReportingTableRowViewModel = {
  foraAgreementNumber: '00000000004010000783',
  policyNumber: '500000001091',
  employee: {
    employeeId: '197605121234',
    partnerNumberIndividual: '0032695383',
    identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
    firstName: 'Anna',
    lastName: 'Annasson',
    address: {
      streetAddress: 'Street address',
      streetAddress2: '',
      postalCode: '11111',
      city: 'Stockholm',
      countryCode: 'SE',
    },
    birthDate: '',
    deathDate: '',
    isVerified: false,
  },
  employmentPeriods: [
    {
      employmentStartDate: '2021-01-01',
      employmentEndDate: '2022-01-01',
      markups: [
        {
          faGroupId: '0000039884',
          fokId: '12345',
          fokText: 'Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
          startDate: '2021-01-01T00:00:00',
          endDate: '2022-01-01T00:00:00',
          status: MarkupStatusEnum.Expired,
        },
      ],
      employmentStatus: EmploymentPeriodStatusEnum.Expired,
      fokParameterChoices: [],
    },
  ],
  payAmountDraft: 12345,
  payAmountReported: null,
  attributablePayDraft: null,
  attributablePayReported: null,
  isInactive: true,
  isTerminated: true,
  isFuture: false,
  activeMarkup: null,
  availableAttributablePayYears,
  hasFokParameterChoices: false,
  isAbovePensionIncomeAge: false,
};

const employee3: PayReportingTableRowViewModel = {
  foraAgreementNumber: '00000000004010000783',
  policyNumber: '500000001090',
  employee: {
    employeeId: '198411221122',
    partnerNumberIndividual: '0032695385',
    identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
    firstName: 'Olle',
    lastName: 'Olsson',
    address: {
      streetAddress: 'Street address',
      streetAddress2: '',
      postalCode: '11111',
      city: 'Stockholm',
      countryCode: 'SE',
    },
    birthDate: '',
    deathDate: '',
    isVerified: false,
  },
  employmentPeriods: [
    {
      employmentStartDate: '2021-01-01',
      employmentEndDate: null,
      markups: [
        {
          faGroupId: '0000039884',
          fokId: 'FOK456789',
          fokText: 'Arbetare kollektivavtal servicehem',
          startDate: '2021-01-01T00:00:00',
          endDate: null,
          status: MarkupStatusEnum.Active,
        },
      ],
      employmentStatus: EmploymentPeriodStatusEnum.Active,
      fokParameterChoices: [],
    },
  ],
  payAmountDraft: 25000,
  payAmountReported: null,
  attributablePayDraft: null,
  attributablePayReported: null,
  isInactive: false,
  isTerminated: false,
  isFuture: false,
  activeMarkup: {
    faGroupId: '0000039884',
    fokId: 'FOK456789',
    fokText: 'Arbetare kollektivavtal servicehem',
    startDate: '2021-01-01T00:00:00',
    endDate: null,
    fokParameterChoices: [],
    fokIsExpiring: null,
    status: MarkupStatusEnum.Active,
  },
  availableAttributablePayYears,
  hasFokParameterChoices: false,
  isAbovePensionIncomeAge: false,
};

const employee4: PayReportingTableRowViewModel = {
  foraAgreementNumber: '00000000004010000783',
  policyNumber: '500000001093',
  employee: {
    employeeId: '194411221122',
    partnerNumberIndividual: '0032695386',
    identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
    firstName: 'Klara',
    lastName: 'Klarsson',
    address: {
      streetAddress: 'Street address',
      streetAddress2: '',
      postalCode: '11111',
      city: 'Stockholm',
      countryCode: 'SE',
    },
    birthDate: '',
    deathDate: '',
    isVerified: false,
  },
  employmentPeriods: [
    {
      employmentStartDate: '2021-01-01',
      employmentEndDate: null,
      markups: [
        {
          faGroupId: '0000039884',
          fokId: '12345',
          fokText: 'Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
          startDate: '2021-01-01T00:00:00',
          endDate: null,
          status: MarkupStatusEnum.Active,
        },
      ],
      employmentStatus: EmploymentPeriodStatusEnum.Active,
      fokParameterChoices: [],
    },
  ],
  payAmountDraft: null,
  payAmountReported: 15000,
  attributablePayDraft: null,
  attributablePayReported: [
    {
      attributablePayAmount: 1000,
      attributablePayMonth: '202302',
    },
    {
      attributablePayAmount: 2000,
      attributablePayMonth: '202305',
    },
  ],
  isInactive: false,
  isTerminated: false,
  isFuture: false,
  activeMarkup: {
    faGroupId: '0000039884',
    fokId: '12345',
    fokText: 'Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
    startDate: '2021-01-01T00:00:00',
    endDate: null,
    fokParameterChoices: [],
    fokIsExpiring: null,
    status: MarkupStatusEnum.Active,
  },
  availableAttributablePayYears,
  hasFokParameterChoices: false,
  isAbovePensionIncomeAge: true,
};

const employee5: PayReportingTableRowViewModel = {
  foraAgreementNumber: '00000000004010000783',
  policyNumber: '500000001091',
  employee: {
    employeeId: '197605121234',
    partnerNumberIndividual: '0032695383',
    identificationType: EmployeeIdentificationType.PersonalIdentityNumber,
    firstName: 'Annika',
    lastName: 'Svensson',
    address: {
      streetAddress: 'Street address',
      streetAddress2: '',
      postalCode: '11111',
      city: 'Stockholm',
      countryCode: 'SE',
    },
    birthDate: '',
    deathDate: '',
    isVerified: false,
  },
  employmentPeriods: [
    {
      employmentStartDate: '2021-01-01',
      employmentEndDate: '2022-01-01',
      markups: [
        {
          faGroupId: '0000039884',
          fokId: '12345',
          fokText: 'Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
          startDate: '2021-01-01T00:00:00',
          endDate: '2022-01-01T00:00:00',
          status: MarkupStatusEnum.Expired,
        },
      ],
      employmentStatus: EmploymentPeriodStatusEnum.Expired,
      fokParameterChoices: [],
    },
  ],
  payAmountDraft: 12345,
  payAmountReported: null,
  attributablePayDraft: null,
  attributablePayReported: null,
  isInactive: true,
  isTerminated: true,
  isFuture: false,
  activeMarkup: null,
  availableAttributablePayYears,
  hasFokParameterChoices: false,
  isAbovePensionIncomeAge: false,
};

const mockPayMonthDataAllKinds: PayReportingTableViewModel = {
  payReportRows: [employee1, employee2, employee3, employee4, employee5],
  draftUpdatedAt: '2023-12-21T15:53:04.899Z',
};
const mockPayMonthDataNoInactive: PayReportingTableViewModel = {
  payReportRows: [employee1, employee3, employee4, employee5],
  draftUpdatedAt: '2023-12-21T15:53:04.899Z',
};
const mockPayMonthDataNoAttributablePay: PayReportingTableViewModel = {
  payReportRows: [employee1, employee2, employee3, employee5],
  draftUpdatedAt: '2023-12-21T15:53:04.899Z',
};

export const mockPayMonthData = {
  allKinds: mockPayMonthDataAllKinds,
  noInactive: mockPayMonthDataNoInactive,
  noAttributablePay: mockPayMonthDataNoAttributablePay,
};
